import React from 'react'
import { Box, Divider, Text } from '@chakra-ui/react'
import NotAvailable from './NotAvailable'

const PersonalInformation = ({ PersonalInformation }) => {
    return (
        <>
            {
                Object.keys(PersonalInformation).map(item =>
                    <Box key={item}>
                        <Box p="2">
                            <Text fontSize='sm' color="gray.500">{item}</Text>
                            <Text fontSize='md'>{PersonalInformation[item] ? PersonalInformation[item] : <NotAvailable />}</Text>
                        </Box>
                        <Divider />
                    </Box>)
            }
        </>
    )

}
export default PersonalInformation